import React, { useState, useEffect } from 'react';
import './Hero.css';
import { cloudImg } from '../config/images';

const Hero = ({
  title = 'Discover Beautiful Pristine Beaches',
  subtitle = "Experience Kannur's Hidden Coastal Gems",
  posterImg = cloudImg('payyamballam.jpg'),
  videoSrc = '/videos/Rediscover_stillness_at_the_shore_version_1.mp4'
}) => {
  // Default to mobile/poster-only before the effect runs, so phones never
  // start fetching the 2.9MB background video for a layout we'd immediately replace.
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 768px)');
    setIsMobile(mql.matches);
    const handleChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return (
    <header className="hero">
      {isMobile ? (
        <img
          className="hero-poster-img"
          src={posterImg}
          alt={title}
          fetchpriority="high"
        />
      ) : (
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster={posterImg}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </header>
  );
};

export default Hero;
